import { Component, Input, Output, EventEmitter }             from '@angular/core';
import { Router }                                             from '@angular/router';
import { Wave }                                               from '../../../../../models/program/wave';
import { SessionDetails }                                     from '../../../../../models/program/session-details';
import { CsvService }                                         from '../../../../../dashboard/program-list/csv.service';
import { BatchResponse }                                      from '../../../../../models/program/batch-response';
import { UtilsService }                                       from '../../../../../shared/utils.service';

@Component({
  selector: 'app-teams-list',
  templateUrl: './teams-list.component.html',
  styleUrls: ['./teams-list.component.less'],
  providers: [UtilsService]
})

export class TeamsListComponent {
  @Input() session: SessionDetails;
  @Input() programId: number;
  @Input() showHeader?: boolean;
  @Input() simplifiedInterface = false;
  @Output() update: EventEmitter<number> = new EventEmitter<number>();
  @Output() openSessionSettings: EventEmitter<number> = new EventEmitter<number>();
  @Output() postBatch: EventEmitter<BatchResponse> = new EventEmitter<BatchResponse>();
  assignUsers: boolean;
  deleteTeam?: number;
  errors: string[]; // TO DO - display errors when applicable
  batchResponse: BatchResponse;

  constructor(
    private router: Router,
    private csvService: CsvService,
    private utils: UtilsService
  ) { }

  get showUserUpload() {
    return !this.session.automatic
    && this.session.joining_closes <= this.utils.createNowReleaseString()
    && this.session.start_date > this.utils.createNowReleaseString();
  }

  batchWatch(batchResponse: BatchResponse) {
    this.assignUsers = false;
    this.batchResponse = batchResponse;
  }

  resetData(boolean: Boolean) {
    this.assignUsers = false;
    this.batchResponse = null;
    window.location.reload();
  }

  createNowReleaseString(): string {
    let now: Date = new Date(Date.now());
    let month: string = this.utils.formatDateTime(now.getMonth() + 1);
    let day: string = this.utils.formatDateTime(now.getDate());
    let hour: string = this.utils.formatDateTime(now.getHours());
    let minutes = '00';
    let seconds = '00';
    let dateString: any = `${now.getFullYear()}-${month}-${day}`;
    let timeString: any = `${hour}:${minutes}`;
    return `${dateString}T${timeString}:${seconds}`;
  }

  getTeamAssignmentFileUrl(): string {
    return this.csvService.getTeamAssignmentFileUrl(this.programId, this.session.id);
  }

  teamMenuItemSelected(itemName: string, teamId: number): void {
    if (itemName === 'openAsTeam') {
      window.open(`/library?groupselect=${teamId}`);
    } else if (itemName === 'deleteTeam') {
      this.deleteTeam = teamId;
    } else if (itemName === 'teamSettings') {
      this.routeToSettings(teamId);
    } else {
      this.toggleField[itemName];
    }
  }

  toggleField(field: string): void {
    this[field] = !this[field];
  }

  routeToLearners(teamId: number): void {
    this.router.navigate(['dashboard', 'new-programs', this.programId, 'sessions', this.session.id, 'teams', teamId]);
  }

  routeToSession(): void {
    this.router.navigate(['dashboard', 'programs', this.programId, 'sessions', this.session.id]);
  }

  routeToSettings(teamId: number): void {
    this.router.navigate(['dashboard', 'programs', this.programId, 'waves', this.session.id, 'teams', teamId, 'general-settings']);
  }

  goToSessionSettings(): void {
    this.openSessionSettings.emit(this.session.id);
  }

  emitUpdate(emit?: boolean): void {
    if (emit === false) {
      return;
    }
    this.update.emit(this.session.id);
  }

  teamCount(session: SessionDetails): number {
    return Math.max(1, Math.floor(session.user_count / session.min_team_size));
  }

  userCount(session: SessionDetails): number {
    return Math.floor(session.user_count / this.teamCount(session));
  }

}





// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/sessions/session/teams-list/teams-list.component.ts